import { Injectable } from '@angular/core';
import { UserAlertSummary } from '../models/user-alert-summary.model';
import { UserSummary } from '../models/user-summary.model';

@Injectable({
  providedIn: 'root'
})
export class SelectedUsersService {

  constructor() { }

  userList: UserAlertSummary[] = [];

  public AddUser(user: UserAlertSummary): void {
    if (!this.Contains(user.userId)) {
      this.userList.push(user);
    }
  }

  public AddUserSummary(user: UserSummary): void {
    var userAlert = new UserAlertSummary();
    userAlert.fullName = user.fullName;
    userAlert.initials = user.initials;
    userAlert.imageUrl = user.backgroundImage;
    userAlert.title = user.title;
    userAlert.userId = user.userId;

    this.AddUser(userAlert);
  }

  public RemoveUser(userId: string): void {
    for (var i = this.userList.length - 1; i >= 0; i--) {
      if (this.userList[i].userId == userId) {
        this.userList.splice(i, 1);
      }
    }
  }

  public Contains(userId: string): boolean {
    return this.userList.filter((x) => x.userId == userId).length != 0;
  }

  public Count(): number {
    return this.userList.length;
  }

  public Clear(): void {
    this.userList = [];
  }

  public List(): readonly UserAlertSummary[] {
    return this.userList;
  }
}
